export default "__VITE_ASSET__CraIgdMn__"